import { Record } from 'immutable';

import {
  LAYOUT_TYPE,
  LAYOUT_TYPE_FULL,
  NAV_STYLE,
  NAV_STYLE_FIXED,
  THEME_COLOR,
  THEME_TYPE,
  THEME_TYPE_SEMI_DARK,
} from '../../constants/ThemeSetting';
import SettingsAction from './settings.actions';

const initData = {
  navStyle: NAV_STYLE_FIXED,
  layoutType: LAYOUT_TYPE_FULL,
  themeType: THEME_TYPE_SEMI_DARK,
  themeColor: THEME_COLOR,

  isDirectionRTL: false,
  locale: {
    languageId: 'english',
    locale: 'en',
    name: 'English',
    icon: 'us',
  },
};

export const SettingRecord = new Record(initData);

const initialState = SettingRecord(initData);

export default function settingsReducer(state = initialState, action) {
  switch (action.type) {
    case THEME_TYPE:
      return state.set('themeType', action.themeType);
    case THEME_COLOR:
      return state.set('themeColor', action.themeColor);
    case NAV_STYLE:
      return state.set('navStyle', action.navStyle);
    case LAYOUT_TYPE:
      return state.set('layoutType', action.layoutType);
    case SettingsAction.ACTION_TYPES.SWITCH_LANGUAGE:
      return state.set('locale', action.payload);
    default:
      return SettingRecord(state);
  }
}
